import { Flex, VStack } from "@chakra-ui/react";

import { computeFeeBreakdown, formatSecurities, offeringToFeeRates } from "@equidefi/shared";
import { Text } from "@equidefi/ui";

import { CurrencyFormatter } from "@/constants/format";

const Row = ({ label, value, bold = false }) => (
  <Flex justify="space-between" w="full">
    <Text m="0" fontWeight={bold ? "bold" : "normal"}>
      {label}
    </Text>
    <Text m="0" fontWeight={bold ? "bold" : "normal"}>
      {value}
    </Text>
  </Flex>
);

/**
 * Shares / Processing Fee / TOTAL DUE breakdown shown inside a selected payment
 * method panel (above its action button) when the investor pays the fees. Renders
 * nothing in issuer-paid mode, preserving today's behavior.
 *
 * `paymentType` is the concrete method for this panel (e.g. "card",
 * "us_bank_account", "customer_balance", "wire", "check") so the fee matches what
 * the backend charges via the same shared helper.
 */
export const ProcessingFeeSummary = ({ investment, offering, paymentType }) => {
  if (!offering?.settings?.investor_pays_fee) return null;

  const breakdown = computeFeeBreakdown(offeringToFeeRates(offering), paymentType, Number(investment?.amount ?? 0));
  const shares = formatSecurities({ quantity: Number(investment?.quantity), offering, capitalize: true }).toString();

  return (
    <VStack align="stretch" spacing={1} my={4}>
      <Row label={shares} value={CurrencyFormatter.format(investment?.amount)} />
      <Row label="Processing Fee" value={CurrencyFormatter.format(breakdown.investorFeeTotal)} />
      <Row label="TOTAL DUE" value={CurrencyFormatter.format(breakdown.chargeAmount)} bold />
    </VStack>
  );
};

export default ProcessingFeeSummary;
